import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatPublicSalaryApplicantList,
	formatPublicSalaryDetail,
	formatPublicSalaryExcelList,
	formatPublicSalaryList,
} from './worker-public-salary.helper';
import { WorkerPublicSalaryActions } from './worker-public-salary.redux';
import {
	IPayloadGetPublicSalaryApplicantListRequest,
	IPayloadGetPublicSalaryDetailRequest,
	IPayloadGetPublicSalaryExcelListRequest,
	IPayloadGetPublicSalaryListRequest,
} from './worker-public-salary.type';

export function* getPublicSalaryListSaga(
	action: PayloadAction<IPayloadGetPublicSalaryListRequest>
) {
	try {
		const { callback, ...params } = action.payload;

		const res: API.ApiResponseSuccess<API.GetPublicSalaryListResponse> =
			yield call(API.getPublicSalaryList, {
				...params,
				isAudit: false,
			});
		const content = formatPublicSalaryList(res?.data?.list);

		yield put(
			WorkerPublicSalaryActions.getPublicSalaryListSuccess({
				...res?.data?.list,
				content,
				totalData: res?.data?.total,
			})
		);
		callback?.({ data: content });
	} catch (error) {
		yield put(WorkerPublicSalaryActions.getPublicSalaryListFailure());
		action.payload.callback?.(error);
	}
}

export function* getPublicSalaryExcelListSaga(
	action: PayloadAction<IPayloadGetPublicSalaryExcelListRequest>
) {
	try {
		const { callback, ...params } = action.payload;
		const res: API.ApiResponseSuccess<API.GetPublicSalaryExcelListResponse> =
			yield call(API.getPublicSalaryList, {
				...params,
				isAudit: false,
			});

		const content = formatPublicSalaryExcelList(res?.data?.list);

		callback?.({ data: content });
		yield put(WorkerPublicSalaryActions.getPublicSalaryExcelListSuccess());
	} catch (error) {
		yield put(WorkerPublicSalaryActions.getPublicSalaryExcelListFailure());
		action.payload.callback?.({ error });
	}
}

export function* getPublicSalaryDetailSaga(
	action: PayloadAction<IPayloadGetPublicSalaryDetailRequest>
) {
	try {
		const { callback, ...rest } = action.payload;
		const res: API.ApiResponseSuccess<API.GetPublicSalaryDetailResponse> =
			yield call(API.getPublicSalaryList, {
				...rest,
				isAudit: true,
			});
		const content = formatPublicSalaryDetail(res?.data);

		yield put(
			WorkerPublicSalaryActions.getPublicSalaryDetailSuccess({
				publicSalaryDetail: content,
			})
		);
		callback?.();
	} catch (error) {
		yield put(WorkerPublicSalaryActions.getPublicSalaryDetailFailure());
		action.payload.callback?.(error);
	}
}

export function* getPublicSalaryApplicantListSaga(
	action: PayloadAction<IPayloadGetPublicSalaryApplicantListRequest>
) {
	try {
		const { callback, ...params } = action.payload;

		const res: API.ApiResponseSuccess<API.GetPublicSalaryApplicantListResponse> =
			yield call(API.getPublicSalaryApplicantList, params);
		const content = formatPublicSalaryApplicantList(res?.data?.content);

		yield put(
			WorkerPublicSalaryActions.getPublicSalaryApplicantListSuccess({
				...params,
				content,
				total: res?.data?.total,
			})
		);
		callback?.({ data: content });
	} catch (error) {
		yield put(WorkerPublicSalaryActions.getPublicSalaryApplicantListFailure());
		action.payload.callback?.(error);
	}
}
